import { Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

export class AbstractAutocompleteData implements ControlValueAccessor {

  constructor(@Self() public ngControl: NgControl) {
    ngControl.valueAccessor = this;
  }

  registerOnChange(): void {
  }

  registerOnTouched(): void {
  }

  setDisabledState(): void {
  }

  writeValue(val: any): void {
  }
}
